"use client";

import Link from "next/link";
import { Music2, Guitar, Mic, Piano, Drum, Headphones } from "lucide-react";

interface PopularCategoryCardProps {
  icon: React.ComponentType<{ className?: string }>;
  label: string;
  href?: string;
}

const popularCategories: PopularCategoryCardProps[] = [
  { icon: Music2, label: "바이올린", href: "/list?category=violin" },
  { icon: Guitar, label: "일렉기타 / 통기타", href: "/list?category=guitar" },
  { icon: Mic, label: "마이크", href: "/list?category=mic" },
  { icon: Piano, label: "미디키보드 / 신디사이저", href: "/list?category=keyboard" },
  { icon: Drum, label: "전자드럼", href: "/list?category=edrum" },
  { icon: Headphones, label: "오디오 인터페이스 / 헤드폰", href: "/list?category=audio" },
];

export default function PopularCategoriesSection() {
  return (
    <section className="relative overflow-hidden bg-white text-gray-900">
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-24 py-16 sm:py-20 lg:py-24">
        {/* 섹션 헤더 */}
        <div className="text-center mb-12 sm:mb-16">
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold leading-tight tracking-[-0.02em] mb-4 text-gray-900">
            요즘 많은 사람들이 찾고 있어요
          </h2>
        </div>

        {/* 인기 카테고리 카드 그리드 */}
        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-3 gap-4 sm:gap-6">
          {popularCategories.map((category, index) => (
            <PopularCategoryCard key={index} {...category} />
          ))}
        </div>
      </div>
    </section>
  );
}

function PopularCategoryCard({
  icon: Icon,
  label,
  href = "/list",
}: PopularCategoryCardProps) {
  const CardContent = (
    <div className="group relative h-full w-full rounded-2xl border border-gray-200 bg-gray-50/50 p-6 sm:p-8 hover:bg-white hover:border-[#7A56E8]/30 hover:shadow-lg transition-all duration-300 transform hover:scale-[1.02] cursor-pointer">
      {/* 콘텐츠 */}
      <div className="flex flex-col items-center text-center space-y-3 sm:space-y-4">
        {/* 아이콘 */}
        <div className="p-3 rounded-xl bg-gradient-to-br from-gray-100 to-gray-50 border border-gray-200 group-hover:from-[#F5F3FF] group-hover:to-[#EDE9FE] group-hover:border-[#7A56E8]/30 transform group-hover:scale-110 transition-all duration-300">
          <Icon className="w-8 h-8 sm:w-10 sm:h-10 lg:w-12 lg:h-12 text-[#7A56E8] group-hover:text-[#6D46D1]" strokeWidth={2} />
        </div>

        {/* 라벨 */}
        <h3 className="text-sm sm:text-base lg:text-lg font-semibold text-gray-900 group-hover:text-[#7A56E8] transition-colors tracking-tight leading-tight">
          {label}
        </h3>
      </div>
    </div>
  );

  if (href) {
    return (
      <Link href={href} className="block h-full">
        {CardContent}
      </Link>
    );
  }

  return CardContent;
}

